document.addEventListener('DOMContentLoaded', function () {
  var buttonSelector = document.querySelector('body[template="bundle-products-editable"] product-form.product-form');
  if(buttonSelector){
   buttonSelector.classList.remove('hide');
  }  
  var subscriptionLength = document.querySelectorAll('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available').length;
  if(subscriptionLength > 2){
      var getClass = document.querySelectorAll('.product-tampon-tmpt-itg .skio-group-container:nth-of-type(2) label.skio-group-label');
      document.querySelector('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available:nth-of-type(1)').style.cssText = 'display:none;'
      getClass.forEach(function(label) {
        // Check if the custom content is already added
        if (!label.querySelector('.cstm-content-skio-li')) {
          var element = document.createElement("div");
          element.classList.add("cstm-content-skio-li");
          element.innerHTML = `
            <div class="skio-promo-highlight">
              20% off your first order + FREE Zipper Pouch!
            </div>
            <ul>
              <li>Save 20% on first order</li>
              <li>10% off all recurring orders</li>
              <li>Change renewal date or cancel anytime</li>
              <li>Exclusive subscriber discounts</li>
            </ul>
`          ;
          var topline = label.querySelector('.skio-group-topline');
          var content = label.querySelector('.skio-group-content');
          
          label.insertBefore(element, content);
        }
      });
      
      // by default select subscribe plan
      
        setTimeout(function () {
          var groupContainers = document.querySelectorAll('.skio-group-container');
          groupContainers.forEach(function (container) {
            var title = container.querySelector('.skio-group-title');   
            if (title) {
              var titleText = title.childNodes[0]?.textContent.trim();
              var radioInput = container.querySelector('input[type="radio"]');
              if (radioInput) {
                if (titleText === "Prepaid") {
                  radioInput.checked = false;
                }
                if (titleText === "SUBSCRIBE & SAVE") {
                  radioInput.checked = true;
                }
              }
            }
          });
        }, 1000);    
  }else{
    var getClass = document.querySelectorAll('.product-tampon-tmpt-itg .skio-group-container:nth-of-type(1) label.skio-group-label');
      getClass.forEach(function(label) {
        // Check if the custom content is already added
        if (!label.querySelector('.cstm-content-skio-li')) {
          var element = document.createElement("div");
          element.classList.add("cstm-content-skio-li");
          element.innerHTML = `
            <div class="skio-promo-highlight">
              20% off your first order + FREE Zipper Pouch!
            </div>
            <ul>
              <li>Save 20% on first order</li>
              <li>10% off all recurring orders</li>
              <li>Change renewal date or cancel anytime</li>
              <li>Exclusive subscriber discounts</li>
            </ul>
`          ;
          var topline = label.querySelector('.skio-group-topline');
          var content = label.querySelector('.skio-group-content');
      
          label.insertBefore(element, content);
        }
      });
      
      // by default select subscribe plan
      
        setTimeout(function () {}, 1000);
          var groupContainers = document.querySelectorAll('.skio-group-container');
          groupContainers.forEach(function (container) {
            var title = container.querySelector('.skio-group-title');   
            if (title) {
              var titleText = title.childNodes[0]?.textContent.trim();
              var radioInput = container.querySelector('input[type="radio"]');
              if (radioInput) {
                if (titleText === "Prepaid") {
                  radioInput.checked = false;
                }
                if (titleText === "SUBSCRIBE & SAVE") {
                  radioInput.checked = true;
                }
              }
            }
          });
        
  }
});


/*-----------------------(RJ/01/02)--------------------------*/
document.addEventListener('DOMContentLoaded', function(){
const option = document.querySelector('.skio-group-content select.skio-frequency option[value="1563656365"]');
if (option) {
  option.selected = true;
}

function one_time_piece_val(){ 
         var selectSubsVals = document.querySelectorAll('.varinat-and-quantity-box select.b-var option');       
         selectSubsVals.forEach(function(selectSubsVal){
           var select_value = selectSubsVal.value;
           var select_discount_price = selectSubsVal.getAttribute('variant-price');
          
               select_discount_price = select_discount_price.split('$');
               select_discount_price = select_discount_price[1];
          
           var variantOptions = document.querySelectorAll('.custom-variant-options.bbpa-pro-detail.product-form__input label');
           variantOptions.forEach(function(variantOption){
             var variantVals = variantOption.getAttribute('new-value');
             if(variantVals == select_value){
               //console.log(variantVals,'--',select_discount_price);
               var select_discount_price_ = select_discount_price / variantVals
                   select_discount_price_ = select_discount_price_.toFixed(2);
               variantOption.querySelector('span').textContent = `($${select_discount_price_}/piece)`
             }
           });
         });
  
}
function subscribe_piece_value(){
  var selectSubsVals = document.querySelectorAll('.varinat-and-quantity-box select.b-var option');
   selectSubsVals.forEach(function(selectSubsVal){
     var select_value = selectSubsVal.value;
     var select_discount_price = selectSubsVal.getAttribute('discount-price');
         select_discount_price = select_discount_price.split('$');
         select_discount_price = select_discount_price[1];
     var variantOptions = document.querySelectorAll('.custom-variant-options.bbpa-pro-detail.product-form__input label');
     variantOptions.forEach(function(variantOption){
       var variantVals = variantOption.getAttribute('new-value');
       var product_piece_text = variantOption.getAttribute('product_piece_text');
       if(variantVals == select_value){
         //console.log(variantVals,'--','subs');
         var select_discount_price_ = select_discount_price / variantVals
             select_discount_price_ = select_discount_price_.toFixed(2);
             variantOption.querySelector('span').textContent = `($${select_discount_price_}/${product_piece_text})`
       }
     });
   });
  
}

one_time_piece_val();
subscribe_piece_value();
  
   
  
var subsblocks = document.querySelectorAll('.product-tampon-tmpt-itg .skio-group-input');
subsblocks.forEach(function(subsblock){
  subsblock.addEventListener('change', function(event){
    var subscriptionLength = document.querySelectorAll('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available').length;
    
    var selectedVariant = document.querySelector('.varinat-and-quantity-box .product-form__input input:checked').value
    if(selectedVariant){
      buy_from_target(selectedVariant);
    }
   
    var checkedInput = event.target; 
    if (checkedInput.checked) {
      var subs_val_ = checkedInput.value;
      
       if(subscriptionLength > 2){ 
           document.querySelector('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available:nth-of-type(2)').classList.remove('active-option'); 
         }else{
           document.querySelector('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available:nth-of-type(1)').classList.remove('active-option'); 
         } 
      if(subs_val_){        
        subscribe_piece_value();
        
      }else{  
        if(subscriptionLength > 2){ 
          document.querySelector('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available:nth-of-type(2)').classList.add('active-option'); 
         }else{
           document.querySelector('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available:nth-of-type(1)').classList.add('active-option'); 
         } 
         one_time_piece_val();
         
      }
     
    } 

     if(checkedInput.checked && subscriptionLength > 2){
       document.querySelector('.product-tampon-tmpt-itg .skio-group-container.skio-group-container--available:nth-of-type(2)').classList.add('active-option');
     }
  });
});
function isIOS() {
  return /iPhone|iPad|iPod/.test(navigator.userAgent);
}
if (isIOS()) {
  document.body.classList.add('ios-device');
}else{
  document.body.classList.add('chrome-device');
}
  
var quantity_selector = document.querySelector('.quantity__input');
if(quantity_selector){ 
  quantity_selector.addEventListener('blur',function(this_){
    var value = Number(quantity_selector.value);
    var max_value = Number(quantity_selector.getAttribute('max'));
     //console.log(max_value,value)
    if(value > max_value){
      quantity_selector.value = max_value
    }
  });
  quantity_selector.addEventListener("keydown", function(event) {
        if (event.key == "Enter") {
            event.preventDefault(); 
        }
  });
}
document.querySelectorAll('.bundle-products .bundle-product').forEach(function(bundleProduct) {
    bundleProduct.addEventListener('click', function(this_) {       
        var checkbox = bundleProduct.querySelector('input[type=checkbox]');
        var inputCheck = checkbox.checked;  // Check if the checkbox is checked
        //console.log(inputCheck, 'ads');      
        if (inputCheck == false) {  
            checkbox.checked = true; 
            bundleProduct.classList.add('active');  
        } else {  
            checkbox.checked = false; 
            bundleProduct.classList.remove('active'); 
        }
    });
});
function buy_from_target(id){
  var buy_btn = document.querySelector('a.product-form__submit.btn');
  if(buy_btn){
    if (id == '16') {
      var subs_val = document.querySelector('.product-tampon-tmpt-itg .skio-group-input:checked').value
      
      //console.log(subs_val,'val');
      if(subs_val){
        buy_btn.classList.remove('show');
        document.querySelector('.product__info-container .product-form').style.display = 'block';
       // console.log('subs');
      }else {
          buy_btn.classList.add('show');
          document.querySelector('.product__info-container .product-form').style.display = 'none';
          //console.log('one time');
      }           
    }else{
       buy_btn.classList.remove('show');
       document.querySelector('.product__info-container .product-form').style.display = 'block';
    }
  }  
}
document.querySelectorAll('.varinat-and-quantity-box input.product_custom_variant').forEach(function(input) {
    input.addEventListener('change', function() {
        var id = this.value;
        buy_from_target(id);         
    });
});

  
});
 

